import { type Listing } from '@pkgs/api/index';

import { useJsonLd } from '@/hooks/useJsonLd';

export const JsonLdScripts = ({
  listing,
  title,
  description,
  imageUrl,
}: {
  listing: Listing;
  title: string;
  description: string;
  imageUrl: string;
}) => {
  const { productJsonLd, realEstateListingJsonLd, breadcrumbListJsonLd } = useJsonLd(title, listing, description, imageUrl);
  return (
    <>
      {!!productJsonLd && (
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify(productJsonLd).replace(/</g, '\\u003c'),
          }}
        />
      )}
      {!!realEstateListingJsonLd && (
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify(realEstateListingJsonLd).replace(/</g, '\\u003c'),
          }}
        />
      )}
      {!!breadcrumbListJsonLd && (
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify(breadcrumbListJsonLd).replace(/</g, '\\u003c'),
          }}
        />
      )}
    </>
  );
};
